import { Gallery } from 'stream-chat-react'
import { Attachment } from 'stream-chat'
import React, { useMemo } from 'react'
import { createStyles } from '@codeleap/styles'
import { CSSInterpolation } from '@emotion/serialize'

type ImageGridProps = {
  images: Attachment[]
}

export const ImageGrid = ({ images }: ImageGridProps) => {
  if (images.length === 0) return null

  const isGridLayout = images.length >= 3
  const styles = useMemo(() => isGridLayout ? gridLayoutStyles : singleOrTwoImageStyles, [isGridLayout])

  return (
    <div css={[styles.wrapper] as unknown as CSSInterpolation}>
      <Gallery
        images={images.map(img => ({
          ...img,
        }))}
      />
    </div>
  )
}

const singleOrTwoImageStyles = createStyles(theme => ({
  wrapper: {
    position: 'relative',
    maxWidth: 'fit-content',
    width: 'auto',
    borderRadius: theme.radius.regular,
    overflow: 'hidden',
    '& .str-chat__gallery': {
      display: 'grid !important',
      gridTemplateColumns: '1fr !important',
      gap: '4px !important',
      width: 'fit-content !important',
      borderRadius: theme.radius.regular,
      overflow: 'hidden',
    },
    '& .str-chat__gallery-image': {
      '& .str-chat__base-image': {
        borderRadius: '0px !important',
      },
      '& img': {
        borderRadius: '0px !important',
      },
    },
  },
}))

const gridLayoutStyles = createStyles(theme => {
  const imageSize = theme.size.imageSize
  const gridContainerWidth = imageSize * 2 + theme.spacing.value(0.25) // 2 imagens + 1 gap

  return {
    wrapper: {
      position: 'relative',
      maxWidth: `${gridContainerWidth}px`,
      width: `${gridContainerWidth}px`,
      borderRadius: theme.radius.regular,
      overflow: 'hidden',
      '& .str-chat__gallery': {
        display: 'grid !important',
        gridTemplateColumns: 'repeat(2, 1fr) !important',
        gap: `${theme.spacing.value(0.25)}px !important`,
        width: '100% !important',
        borderRadius: theme.radius.regular,
        overflow: 'hidden',
      },
      '& .str-chat__gallery-image': {
        position: 'relative',
        width: `${imageSize}px !important`,
        height: `${imageSize}px !important`,
        minWidth: `${imageSize}px !important`,
        minHeight: `${imageSize}px !important`,
        maxWidth: `${imageSize}px !important`,
        maxHeight: `${imageSize}px !important`,
        overflow: 'hidden',
        cursor: 'pointer',
        '& .str-chat__base-image': {
          borderRadius: '0px !important',
        },
        '& img': {
          width: '100% !important',
          height: '100% !important',
          objectFit: 'cover !important',
          borderRadius: 'theme.radius(0) !important',
        },
      },
      '& .str-chat__gallery-placeholder': {
        width: `${imageSize}px !important`,
        height: `${imageSize}px !important`,
        minWidth: `${imageSize}px !important`,
        minHeight: `${imageSize}px !important`,
        maxWidth: `${imageSize}px !important`,
        maxHeight: `${imageSize}px !important`,
        borderRadius: '0px !important',
        border: 'none',
        padding: 0,
        '& > div': {
          borderRadius: '0px !important',
          inset: '0px !important',
        },
      },
    },
  }
})
